import { Flex, Image, Link } from '@chakra-ui/react'
import React, { VFC } from 'react'

export const Footer: VFC = () => {
  return (
    <Flex
      as={'footer'}
      w={'100%'}
      backgroundColor={'#00205b'}
      borderTop={'1px solid #596e94'}
      h={'186px'}
      minH={'186px'}
      justifyContent={'center'}
      align={'center'}
    >
      <Link href={'https://www.kyoto-u.ac.jp/'}>
        <Image src={`${import.meta.env.BASE_URL}footer-logo.svg`} alt={'京都大学'} />
      </Link>
    </Flex>
  )
}
